import { createReducer, on, State, Action } from '@ngrx/store';
import { IApplication } from '@shared/interfaces/applications.interface';
import { LOAD_APPS, LOAD_APPS_SUCCESS, LOAD_APPS_ERROR } from '@store/actions';

export interface ApplicationsState {
  apps: IApplication[];
  loaded: boolean;
  loading: boolean;
  error: any;
}

export const ApplicationsInitialState: ApplicationsState = {
  apps: [],
  loaded: false,
  loading: false,
  error: null,
};

const _ApplicationsReducer = createReducer(
  ApplicationsInitialState,
  // Disparar la acción y poner el louded en true para mostrar al usuario un aviso por pantalla
  on(LOAD_APPS, (state) => ({ ...state, loading: true })),

  // Cargar los usuarios
  on(LOAD_APPS_SUCCESS, (state, { applications }) => ({
    ...state,
    loading: false,
    loaded: true,
    apps: [...applications],
  })),

  // Se dispara para mostar el error si la operación de cargar usuarios falla
  on(LOAD_APPS_ERROR, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),
);
export function ApplicationsReducer(state, action: Action) {
  return _ApplicationsReducer(state, action);
}
